import { Text } from "react-native";
import { ResidentModel } from "../../../services/api/types/residents/models/ResidentModel";
import { SingleHandoverAppointmentModel } from "../../../services/api/types/shiftHandover/models/SingleHandoverAppointmentModel";
import { format } from "date-fns";
import { TaskItem } from "./TaskItem";

export interface Props {
  residents: ResidentModel[];
  appointment: SingleHandoverAppointmentModel;
  onRowPress: (
    residentId: number | undefined,
    appointment: SingleHandoverAppointmentModel,
  ) => void;
  handleMarkAsDone: (appointment) => void;
  isTodayCompleted: boolean | undefined;
  allResidents: boolean;
}

export function TodayTaskItem({
  residents,
  appointment,
  onRowPress,
  handleMarkAsDone,
  isTodayCompleted,
  allResidents,
}: Props) {
  const preparationNeeded = !!appointment.preparation_needed;

  return (
    <TaskItem
      residents={residents}
      onRowPress={() => {
        const residentId =
          residents?.length === 1 ? residents[0]?.id : undefined;
        onRowPress(residentId, appointment);
      }}
      backgroundColourClass="bg-white"
      isCompleted={isTodayCompleted}
      handleMarkAsDone={() => handleMarkAsDone(appointment)}
      renderContent={() => (
        <Text className="text-base">
          {`${appointment?.title} (${appointment?.starts_at ? format(appointment?.starts_at, "dd-MM-yyyy HH:mm") : ""}${appointment?.location_description ? ` - ${appointment?.location_description}` : ""})`}
        </Text>
      )}
      allResidents={allResidents}
      preparationNeeded={preparationNeeded}
    />
  );
}
